import React from 'react';
import useTitle from '../../../hooks/useTitle';

const Claim = () => {
    return (
        <div className='bg-base-200'>
            <div className='text-center p-32'>
                <h1 className='text-5xl font-bold my-16 mb-2'>Claim Your Free Strategy Call!</h1>
                <p>Experience what I can do for you first hand. Get a free strategy call via phone or video chat, learn how to maximise your workouts and get advice specific to you and your fitness goals. If you choose to work with me, that's great. If not, that's cool too. </p>
                <button className='btn btn-outline btn-secondary mt-4'>CLAIM OFFER</button>
            </div>
        </div>
    );
};

export default Claim;